import {Component, NgZone, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Settings} from '@orga-app/settings/settings.model';
import * as fromBenutzerRollenPage from './benutzer-rollen.reducer';
import * as actionsUi from './benutzer-rollen.actions.ui';
import {
    Benutzer,
    FunktionsbereichRollen,
    Rolle,
    RolleBenutzer,
    RolleBenutzerMultiRequest,
    RolleBenutzerRequest,
    RolleBenutzerTotal
} from '../../../clients/benutzerverwaltung';
import {
    GetBenutzerListeAction,
    GetFunktionsbereicheRollenAction,
    GetRolleBenutzerAction,
    GetRolleBenutzerTotalAction,
    PostRolleBenutzerEntfernenAction,
    PostRolleBenutzerHinzufuegenMultiAction
} from '../../../client-ngrx/benutzerverwaltung';
import {select, Store} from '@ngrx/store';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';

@Component({
    selector: 'app-benutzer-rollen',
    templateUrl: './benutzer-rollen.page.html',
    styleUrls: ['./benutzer-rollen.page.scss'],
})
export class BenutzerRollenPage implements OnInit {
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    rolleBenutzerTotal$: Observable<RolleBenutzerTotal>;
    rolleBenutzerTotalUiLaden$: Observable<boolean>;
    rolleBenutzerTotalUiFehler$: Observable<boolean>;
    funktionsbereicheRollenListe$: Observable<Array<FunktionsbereichRollen>>;
    funktionsbereicheRollen$: Observable<Array<ListInputItem>>;
    funktionsbereicheRollenUiLaden$: Observable<boolean>;
    funktionsbereicheRollenUiFehler$: Observable<boolean>;
    funktionsbereicheRollenUiFehlerObjekt$: Observable<any>;
    funktionsbereicheRollenUiSelektiert$: Observable<Rolle>;
    rolleBenutzerListe$: Observable<Array<RolleBenutzer>>;
    rolleBenutzerListeUiLaden$: Observable<boolean>;
    rolleBenutzerListeUiFehler$: Observable<boolean>;
    rolleBenutzerListeUiFehlerObjekt$: Observable<any>;
    rolleBenutzerListeUiSelektiert$: Observable<RolleBenutzer>;
    rolleBenutzerListeSubscription: Subscription;
    benutzerListeUi$: Observable<Array<ListInputItem>>;
    benutzerListe$: Observable<Array<Benutzer>>;
    benutzerListeUiLaden$: Observable<boolean>;
    benutzerListeUiFehler$: Observable<boolean>;
    benutzerListeUiFehlerObjekt$: Observable<any>;
    selectedBenutzerIds$: Observable<Array<string>>;
    benutzerZuordnenAktiv$: Observable<boolean>;
    rolle: Rolle = null;

    infoBenutzerAnzeigen$: Observable<boolean>;
    standardBenutzerAnzeigen$: Observable<boolean>;
    private aiName = 'BenutzerRollenPage';

    constructor(
        private store: Store<fromBenutzerRollenPage.PageState>,
        private ngZone: NgZone,
        private settingsProvider: SettingsProvider) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        // this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.rolleBenutzerTotal$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerTotal));
        this.rolleBenutzerTotalUiLaden$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerTotalUiLaden));
        this.rolleBenutzerTotalUiFehler$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerTotalUiFehler));

        this.funktionsbereicheRollen$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollen));
        this.funktionsbereicheRollenListe$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollenListe));
        this.funktionsbereicheRollenUiLaden$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollenUiLaden));
        this.funktionsbereicheRollenUiFehler$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollenUiFehler));
        this.funktionsbereicheRollenUiFehlerObjekt$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollenUiFehlerObjekt));
        this.funktionsbereicheRollenUiSelektiert$ = this.store.pipe(select(fromBenutzerRollenPage.getFunktionsbereicheRollenUiSelektiert));
        this.rolleBenutzerListe$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerListe));

        this.rolleBenutzerListeUiLaden$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerListeUiLaden));
        this.rolleBenutzerListeUiFehler$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerListeUiFehler));
        this.rolleBenutzerListeUiFehlerObjekt$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerListeUiFehlerObjekt));
        this.rolleBenutzerListeUiSelektiert$ = this.store.pipe(select(fromBenutzerRollenPage.getRolleBenutzerListeUiSelektiert));

        this.benutzerListeUi$ = this.store.pipe(select(fromBenutzerRollenPage.getBenutzerListeUi));
        this.benutzerListeUiLaden$ = this.store.pipe(select(fromBenutzerRollenPage.getBenutzerListeUiLaden));
        this.benutzerListeUiFehler$ = this.store.pipe(select(fromBenutzerRollenPage.getBenutzerListeUiFehler));
        this.benutzerListeUiFehlerObjekt$ = this.store.pipe(select(fromBenutzerRollenPage.getBenutzerListeUiFehlerObjekt));
        this.selectedBenutzerIds$ = this.store.pipe(select(fromBenutzerRollenPage.getSelectedBenutzerIds));
        this.benutzerZuordnenAktiv$ = this.store.pipe(select(fromBenutzerRollenPage.getBenutzerZuordnenAktiv));

        this.infoBenutzerAnzeigen$ = this.store.pipe(select(fromBenutzerRollenPage.getInfoBenutzerAnzeigen));
        this.standardBenutzerAnzeigen$ = this.store.pipe(select(fromBenutzerRollenPage.getStandardBenutzerAnzeigen));
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.funktionsbereicheUndRollenLaden();
        this.benutzerLaden();
        this.rolleBenutzerTotalLaden();
    }

    ionViewDidLeave() {
        if (this.rolleBenutzerListeSubscription !== undefined) {
            this.rolleBenutzerListeSubscription.unsubscribe();
        }
    }

    // LIZENZ
    async rolleBenutzerTotalLaden() {
        this.store.dispatch(new GetRolleBenutzerTotalAction());
    }

    // FUNKTIONSBEREICH & ROLLEN
    async funktionsbereicheUndRollenLaden() {
        this.store.dispatch(new GetFunktionsbereicheRollenAction());
    }

    async rollenBenutzerLaden(rolle: Rolle) {
        if (rolle != null && rolle.rolle_id != null) {
            this.rolle = rolle;
            this.store.dispatch(new actionsUi.RolleSetzenAction(rolle));
            this.store.dispatch(new GetRolleBenutzerAction(rolle.rolle_id));
        }
    }

    // BENUTZER
    async benutzerLaden() {
        this.store.dispatch(new GetBenutzerListeAction());
    }

    async updateSelectedBenutzer($event: Array<string>) {
        await this.store.dispatch(new actionsUi.SelektierteBenutzerAction($event));
    }


    // VERHEIRATEN & ENTFERNEN
    async benutzerUndRolleVerheiraten() {
        // Benutzerliste laden
        this.store.pipe(select(fromBenutzerRollenPage.getSelectedBenutzerIds)).subscribe(selectedBenutzerIds => {
            if (selectedBenutzerIds != null) {
                if (selectedBenutzerIds.length > 0) {
                    const request = <RolleBenutzerMultiRequest>{
                        rolle_id: this.rolle.rolle_id,
                        funktionsbereich_id: this.rolle.funktionsbereich_id,
                        zeitpunkt_utc: new Date(),
                        benutzer_ids: selectedBenutzerIds
                    };
                    this.store.dispatch(new PostRolleBenutzerHinzufuegenMultiAction(request));
                    this.store.dispatch(new actionsUi.SelektierteBenutzerAction([]));
                }
            }
        }).unsubscribe();
    }

    async benutzerAusRolleEntfernen(benutzer: RolleBenutzer) {
        if (this.rolle != null && this.rolle.rolle_id != null && this.rolle.funktionsbereich_id != null && benutzer != null && benutzer.benutzer_id != null) {
            const request = <RolleBenutzerRequest>{
                rolle_id: this.rolle.rolle_id,
                funktionsbereich_id: this.rolle.funktionsbereich_id,
                zeitpunkt_utc: new Date(),
                benutzer_id: benutzer.benutzer_id
            };
            this.store.dispatch(new PostRolleBenutzerEntfernenAction(request));
        }
    }

    trackByRolleBenutzer(item: RolleBenutzer, index) {
        return item.benutzer_id;
    }

    setzeInfoBenutzerAnzeigen($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeInfoBenutzerAnzeigenAction($event.detail.checked));
    }

    setzeStandardBenutzerAnzeigen($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeStandardBenutzerAnzeigenAction($event.detail.checked));
    }
}
